import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
dayjs.extend(weekday);

// 全局使用中文
dayjs.locale("zh-cn");

// when Monday is the first day of the week
dayjs().weekday(-7); // last Monday
dayjs().weekday(7); // next Monday

export default {
    install(Vue) {
        Vue.config.globalProperties.$dayjs = dayjs;
    },
};
